import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import Fab from '@material-ui/core/Fab';
import Badge from '@material-ui/core/Badge';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import PersonIcon from '@material-ui/icons/Person';
import ja from "date-fns/locale/ja";
import './Css/Grid.css';
import DateFnsUtils from '@date-io/date-fns';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import KyDetails from '../KyDetail/Index';

import * as OwnerMail from './Saga/OwnerMail';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import IconButton from '@material-ui/core/IconButton';
const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');
var moment = require('moment-timezone');


var SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC',
};


function reverseSortDirection(sortDir) {
  return sortDir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC;
}
class SortHeaderCell extends React.Component {
  constructor(props) {
    super(props);

    this._onSortChange = this._onSortChange.bind(this);
  }

  render() {
    var { onSortChange, sortDir, children, ...props } = this.props;
    return (
      <Cell {...props} onClick={this._onSortChange}>

        {children} {sortDir ? (sortDir === SortTypes.DESC ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />) : ''}

      </Cell>
    );
  }

  _onSortChange(e) {

    e.preventDefault();

    if (this.props.onSortChange) {
      this.props.onSortChange(
        this.props.columnKey,
        this.props.sortDir ?
          reverseSortDirection(this.props.sortDir) :
          SortTypes.DESC
      );
    }
  }
}
const columns = [
  {
    key: 'Owner_Name', name: '家主名', width: 150, frozen: true,

  },
  { key: 'bk_name', name: '建物名', width: 60, frozen: true },


  { key: 'so_ymd', name: '送金日', width: 90, frozen: true },
  // { key: 'owner_kaiyaku_date', name: '解約報告日', width: 80, resizable: true },
  { key: 'created_at', name: 'アップロード日時', width: 120 },
  { key: 'send_mail_state', name: '状態', width: 50 },
  { key: 'send_mail_address', name: '送信メール', width: 150 },
  { key: 'send_mail_datetime', name: '送信日', width: 90 },
  { key: 'portal_mail', name: 'メール', width: 150 },



  // { key: 'portal_mail', name: '工事担当', width: 50 },


]




const TatemonoName = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }}><IconButton onClick={() => props.togglesheet(props.owner_mail_list[rowIndex].tatemono_id, props.owner_mail_list[rowIndex].room_id)}><HomeWorkIcon color="primary" /></IconButton> {props.owner_mail_list[rowIndex][column.key]}</Cell>;
const RoomName = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >{props.owner_mail_list[rowIndex][column.key]}</Cell>;


const KaiyakuDate = ({ column, props, rowIndex }) =>
  // <Cell style={{ whiteSpace: "nowrap", width: "100%", height: "100%", background: moment(props.seisan_follow_list[rowIndex][column.key]).tz("Asia/Tokyo").format('YYYY/MM/DD') > moment().tz("Asia/Tokyo").format('YYYY/MM/DD') ? "#87cefa" : "#98fb98" }} >
  <Cell style={{ whiteSpace: "nowrap", width: "100%", height: "100%" }} >

    {props.owner_mail_list[rowIndex][column.key] ? moment(props.owner_mail_list[rowIndex][column.key]).tz("Asia/Tokyo").format('YYYY/MM/DD') : ""}

    <br />{props.owner_mail_list[rowIndex].taikyo_yotei_date && moment(props.owner_mail_list[rowIndex].taikyo_yotei_date).tz("Asia/Tokyo").format('YYYY/MM/DD') !== moment(props.owner_mail_list[rowIndex].kaiyaku_date).tz("Asia/Tokyo").format('YYYY/MM/DD') ? <b>退予 {moment(props.owner_mail_list[rowIndex].taikyo_yotei_date).tz("Asia/Tokyo").format('M/DD')} </b> : ""}

    {/* <Badge badgeContent={"次2日"} color="secondary">　</Badge> */}

  </Cell >;

const KaiyakuOwnerRenraku = ({ column, props, rowIndex, update_kaiyaku_owner_renraku, }) => <Cell style={{ width: "100%", height: "100%" }} >
  {props.owner_mail_list[rowIndex].changing ? <div style={{ zIndex: 3000, background: "rgba(45,45,45, 0.5)", width: "300px", height: "300px", marginLeft: -15, marginTop: -30 }}></div> :

    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja} >

      <KeyboardDatePicker
        disableToolbar
        variant="inline"
        format="yyyy/MM/dd"
        margin="normal"
        id="date-picker-estimate2"
        autoOk={true}
        // label="始期日"
        onChange={(e, value) => update_kaiyaku_owner_renraku(value, props.owner_mail_list[rowIndex].keiyaku_no)}
        name="start_date"
        value={props.owner_mail_list[rowIndex].kaiyaku_owner_renraku ? props.owner_mail_list[rowIndex].kaiyaku_owner_renraku : null}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}

      // invalidDateMessage={"日付の形式が違います"}
      />
    </MuiPickersUtilsProvider>
  }
</Cell >;


const CompletionOwnerReortAt = ({ column, props, rowIndex, update_completion_owner_report_at, }) => <Cell style={{ width: "100%", height: "100%" }} >
  {props.owner_mail_list[rowIndex].changing ? <div style={{ zIndex: 3000, background: "rgba(45,45,45, 0.5)", width: "300px", height: "300px", marginLeft: -15, marginTop: -30 }}></div> :

    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja} >

      <KeyboardDatePicker
        disableToolbar
        variant="inline"
        format="yyyy/MM/dd"
        margin="normal"
        id="date-picker-estimate2"
        autoOk={true}
        // label="始期日"
        onChange={(e, value) => update_completion_owner_report_at(value, props.owner_mail_list[rowIndex].keiyaku_no)}
        name="start_date"
        value={props.owner_mail_list[rowIndex].completion_owner_report_at ? props.owner_mail_list[rowIndex].completion_owner_report_at : null}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}

      // invalidDateMessage={"日付の形式が違います"}
      />
    </MuiPickersUtilsProvider>
  }
</Cell >;

const DateCheck = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap", background: props.owner_mail_list[rowIndex][column.key] ? "#f5f5f5" : "pink", width: "100%", height: "100%" }} >{props.owner_mail_list[rowIndex][column.key] ? moment(props.owner_mail_list[rowIndex][column.key]).tz("Asia/Tokyo").format('YYYY/MM/DD') : ""}</Cell>;


const EstimateCheck = ({ column, props, rowIndex, open_estimate }) =>
  <Cell style={{ whiteSpace: "nowrap", background: props.owner_mail_list[rowIndex][column.key] ? "#f5f5f5" : "pink", width: "100%", height: "100%" }} >
    {props.owner_mail_list[rowIndex][column.key] ? <div><IconButton onClick={() => open_estimate(props.owner_mail_list[rowIndex].keiyaku_no)}><LibraryBooksIcon color="primary" /></IconButton> {moment(props.owner_mail_list[rowIndex][column.key]).tz("Asia/Tokyo").format('YYYY/MM/DD')}</div> : ""}</Cell>;



const Owner = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >  <IconButton onClick={() => props.toggle_owner(props.owner_mail_list[rowIndex].shoyuusha_id)} >< AssignmentIndIcon color="primary" />  </IconButton> {props.owner_mail_list[rowIndex][column.key]}</Cell>;

const Keiyakusha = ({ column, props, rowIndex, onKyopen }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >{props.owner_mail_list[rowIndex].ky_no ? <IconButton onClick={() => onKyopen(props.owner_mail_list[rowIndex].bk_no, props.owner_mail_list[rowIndex].hy_no, props.owner_mail_list[rowIndex].ky_no)}>< PersonIcon color="primary" /></IconButton> : ""} {props.owner_mail_list[rowIndex][column.key]}</Cell>;

const Shunkou = ({ column, props, rowIndex, onKyopen }) => <Cell style={{ whiteSpace: "nowrap" }} >{props.owner_mail_list[rowIndex].shunkou_year && props.owner_mail_list[rowIndex].shunkou_month ? props.owner_mail_list[rowIndex].shunkou_year + '年' + props.owner_mail_list[rowIndex].shunkou_month + "月築" : ""}</Cell>;

const Base = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >{props.owner_mail_list[rowIndex][column.key]}</Cell>;

class CustomerList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: columns,
      reflash: false,

      colSortDirs: {},
      // dataList: new FakeObjectDataListStore(1000000),
      // columnWidths: {
      //   firstName: 240,
      //   lastName: 150,
      //   sentence: 140,
      //   companyName: 60,
      // },
    };




    this._onColumnResizeEndCallback = this._onColumnResizeEndCallback.bind(this);

    this._onSortChange = this._onSortChange.bind(this);



  }
  _onColumnResizeEndCallback(newColumnWidth, columnKey) {

    let columnsset = this.state.columns.map(function (value) {
      if (value.key === columnKey) {
        value.width = newColumnWidth
      }
      return value
    })

    this.setState({ columns: columnsset })

  }





  _onSortChange(columnKey, sortDir) {

    // alert(columnKey)
    // alert(_defaultSortIndexes.indexOf(columnKey))
    let owner_mail_list = this.props.owner_mail_list;
    owner_mail_list.sort((indexA, indexB) => {
      // alert(indexA)
      // alert(indexA[columnKey])
      var valueA = indexA[columnKey];
      var valueB = indexB[columnKey];
      var sortVal = 0;
      if (valueA > valueB) {
        sortVal = 1;
      }
      if (valueA < valueB) {
        sortVal = -1;
      }

      if (!valueA && !valueB) {
        sortVal = 0
      }
      if (!valueA) {
        sortVal = -1
      }
      if (!valueB) {
        sortVal = 1
      }


      if (sortVal !== 0 && sortDir === SortTypes.DESC) {
        sortVal = sortVal * -1;
      }

      return sortVal;
    });
    this.props.change_owner_mail_list(owner_mail_list)
    this.setState({
      // sortedDataList: new DataListWrapper(sortIndexes, this._dataList),
      colSortDirs: {
        [columnKey]: sortDir,
      },
    });
  }

  render() {

    return (
      <div id="seisanlist">
        <Table
          rowHeight={45}
          rowsCount={this.props.owner_mail_list.length}
          onColumnResizeEndCallback={this._onColumnResizeEndCallback}
          width={window.innerWidth - 110}
          height={window.innerHeight - 260}
          headerHeight={40}>
          {columns.map(function (value, i) {
            return <Column
              columnKey={value.key}
              header={<SortHeaderCell
                onSortChange={this._onSortChange}
                sortDir={this.state.colSortDirs[value.key]}
                style={{ whiteSpace: "nowrap" }}>{value.name}</SortHeaderCell>}

              // cell={({ rowIndex, ...props }) => (<Cell style={{ whiteSpace: "nowrap" }} >{this.props.seisan_follow_list[rowIndex][value.key]}</Cell>)}
              cell={({ rowIndex, ...props }) => (

                value.key === "tatemono_name" ? <TatemonoName column={value} props={this.props} rowIndex={rowIndex}></TatemonoName>
                  : value.key === "room_name" ? <RoomName column={value} props={this.props} rowIndex={rowIndex}></RoomName>
                    : value.key === "kaiyaku_date" ? <KaiyakuDate column={value} props={this.props} rowIndex={rowIndex}></KaiyakuDate>
                      : value.key === "order_at" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                        : value.key === "hoshuu_date" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                          : value.key === "kagi_uketori_date" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>

                            : value.key === "completion_at" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                              : value.key === "estimate_request" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                                : value.key === "after_check" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                                  : value.key === "estimate_receives" ? <EstimateCheck column={value} props={this.props} rowIndex={rowIndex} open_estimate={this.open_estimate}></EstimateCheck>
                                    : value.key === "shoyuusha_name" ? <Owner column={value} props={this.props} rowIndex={rowIndex}></Owner>
                                      : value.key === "kei_name" ? <Keiyakusha column={value} props={this.props} rowIndex={rowIndex} onKyopen={this.onKyopen} ></Keiyakusha>
                                        : value.key === "shunkou" ? <Shunkou column={value} props={this.props} rowIndex={rowIndex} ></Shunkou>

                                          : value.key === "kanri_order_at" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                                            : value.key === "kaiyaku_owner_renraku" ? <KaiyakuOwnerRenraku column={value} props={this.props} rowIndex={rowIndex} update_kaiyaku_owner_renraku={this.update_kaiyaku_owner_renraku}></KaiyakuOwnerRenraku>
                                              : value.key === "completion_owner_report_at" ? <CompletionOwnerReortAt column={value} props={this.props} rowIndex={rowIndex} update_completion_owner_report_at={this.update_completion_owner_report_at}></CompletionOwnerReortAt>




                                                : <Base column={value} props={this.props} rowIndex={rowIndex}></Base>
              )}
              width={this.state.columns.filter(a => a.key === value.key)[0].width}
              isResizable={true}
              fixed={value.frozen}

            />
          }, this)}



        </Table >

        <Modal isOpen={this.state.kytoggle} toggle={this.kytoggle} size="xl" fade={false}>

          <ModalHeader toggle={this.kytoggle}>契約情報</ModalHeader>
          {/* <ModalBody> */}
          <KyDetails ky={this.state.ky} />
          {/* </ModalBody> */}
          <ModalFooter>
            {/* <button className="btn btn btn-danger" style={{margin:"5px"}} onClick={this.delete_introductions}>削除する</button>*/}
            {/* <button className="btn btn btn-secondary" style={{ margin: "5px" }} onClick={() => this.props.change_search_modal(false)}>キャンセル</button> */}
          </ModalFooter>
        </Modal >
      </div>
    );
  }
};


//export  default CustomerList;
const mapStateToProps = (state) => {
  return {

    // room_details: state.roomsReducer.room_details,
    owner_mail_list: state.OwnerMail.owner_mail_list,
  }
}
function mapDispatchToProps(dispatch) {
  return {

    change_owner_mail_list(state) {
      dispatch(OwnerMail.change_owner_mail_list(state))
    },


  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);